<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  body,html{
    margin: 0;
    padding: 0;
  }
  .el-submenu__title{
    font-size: 16px;
  }
  .el-menu-item{
    font-size: 16px;
  }
  .breadcrumb{
    background-color: white;
    height: 20px;
    line-height: 20px;
    padding: 15px;
    font-size: 14px;
    border-bottom: solid 1px #EDEDED;
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: white;
  }


  .el-table__expanded-cell[class*=cell] {
    padding: 10px;
  }
  /*定义滚动条轨道 内阴影+圆角*/

  ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
    border-radius: 8px;
    background-color: white;
  }


  /*定义滑块 内阴影+圆角*/

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555; */
    width: 8px;
    height: 8px;
    background: rgba(225, 228, 229, 1);
  }
  .el-carousel__button{
    background-color: #000000;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue